import actions from './actions'
import mutations from './mutations'

const state = {
    formExport: {
        display: false,
        type: ''
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
